import 'bootstrap-daterangepicker/daterangepicker.css';
import 'bootstrap-monthrangepicker/daterangepicker.css';
import 'bootstrap/dist/css/bootstrap.css';
import { useEffect, useRef, useState } from 'react';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import Monthrangepicker from 'react-bootstrap-monthrangepicker';
import './index.css';
import moment from 'moment/moment';


function ToggleButton({button1, button2 , flex='', isDatePicker=false, datePick=null, handleChangeDate}){
    
  const [active, setActive] = useState(0);

  const [clickMonth, setClickMonth] = useState(false);

  useEffect(() => {
    if(active === 0){
      return;
    }
    if(active === 1){
      if(isDatePicker && document.getElementById("date_button")){
        document.getElementById("date_button").click();
      }
    } else {
      if(isDatePicker && document.getElementById("month_button")){
        document.getElementById("month_button").click();
      }
    }
  },[active]);

  const changeStringToDate = (date) => { //DD/MM/YYYY -> Date
    const day = date[0] + date[1];
    const month = date[3] + date[4];
    const year = date[6] + date[7] + date[8] + date[9];
    return new Date(month + '/' + day + '/' + year);
  }

  const ref = useRef(null);

  useEffect(() => {
    if(isDatePicker){
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          const str = document.getElementsByClassName('drp-selected')[0].innerText;
          
          const split = str.split(" ");
          
          if(active === 0){
            return;
          }
          if(split.length === 3){
            const start = ("0" + datePick.fromDate.getDate()).slice(-2) + "/" + ("0" + (datePick.fromDate.getMonth() + 1)).slice(-2) + "/" + datePick.fromDate.getFullYear();
            const end = ("0" + datePick.toDate.getDate()).slice(-2) + "/" + ("0" + (datePick.toDate.getMonth() + 1)).slice(-2) + "/" + datePick.toDate.getFullYear();
            if(active === 1){
              if(start !== split[0] || end !== split[2]) {
                handleChangeDate(changeStringToDate(split[0]), changeStringToDate(split[2]));
              }
              return;
            } else {
              if(start !== '01/'+ split[0] || end !== '01/' + split[2]) {
                handleChangeDate(changeStringToDate('01/'+ split[0]), changeStringToDate('01/' + split[2]));
              }

         
              const pre = document.getElementsByClassName('prev');
              const next = document.getElementsByClassName('next');

              for(let i = 0; i < pre.length; i++) {
                
                pre[i].onmousedown = function(){setClickMonth(!clickMonth)};
              }
              for(let i = 0; i < next.length; i++) {
                
                next[i].onmousedown = function(){setClickMonth(!clickMonth)};
              }
              
              const years = document.getElementsByClassName('month');
    
              if(years && years.length !== 0) {
                let today = new Date();
                
                if(Number(years[0].innerText) > today.getFullYear()) {
                  const months = document.getElementsByClassName('monthPanel');
                    
                  if(months.length !== 0) {
                    for(let i = 0; i < months.length; i++){
                      months[i].classList.remove('available');
                      months[i].classList.add('disabled');
                    }
                  }
                } else {
                      
                  if(Number(years[1].innerText) > today.getFullYear()) {
                    const months = document.getElementsByClassName('monthPanel');
                    
                    let flag = 0;
                    if(months.length !== 0) {
                      
                      for(let i = 0; i < months.length; i++){

                        if(flag === 1) {
                          months[i].classList.remove('available');
                          months[i].classList.add('disabled');
                        }
                        if(Number(months[i].innerText.substring(6)) === today.getMonth() + 1) {
                          flag = 1;
                        }   
                      }
                    } 
                  } else {
                    if(Number(years[1].innerText) === today.getFullYear()) {
                      const months = document.getElementsByClassName('monthPanel');
                      
                      let flag = 0;
                      if(months.length !== 0) {
                        
                        for(let i = 12; i < months.length; i++){
  
                          if(flag === 1) {
                            months[i].classList.remove('available');
                            months[i].classList.add('disabled');
                          }
                          if(Number(months[i].innerText.substring(6)) === today.getMonth() + 1) {
                            flag = 1;
                          }   
                        }
                      }
                    } 
                  }
                }
              }
              return;
            }
          }
        }
      }
        
      document.addEventListener("click", handleClickOutside);
        
      return () => {
        document.removeEventListener("click", handleClickOutside);
      };
    }
  }, [ref, active, datePick]);

  useEffect(() => {
    
    const months = document.getElementsByClassName('monthPanel');
        
    if(months.length !== 0) {
      for(let i = 0; i < months.length; i++){
        months[i].onmousedown = function(){setClickMonth(!clickMonth)};
      }
    }

    const picker = document.getElementsByClassName('daterangepicker');
    for(let i = 0; i < picker.length; i++) {
      picker[i].onmousedown = function(){setClickMonth(!clickMonth)};
    }

    const years = document.getElementsByClassName('month');
    
    if(years && years.length !== 0) {
      let today = new Date();
      
      if(Number(years[0].innerText) > today.getFullYear()) {
        const months = document.getElementsByClassName('monthPanel');
          
        if(months.length !== 0) {
        for(let i = 0; i < months.length; i++){
          months[i].classList.remove('available');
          months[i].classList.add('disabled');
        }
      }
      } else {
                
        if(Number(years[1].innerText) > today.getFullYear()) {

          const months = document.getElementsByClassName('monthPanel');
         
          let flag = 0;
          if(months.length !== 0) {
            for(let i = 0; i < months.length; i++){
              months[i].onmousedown = function(){setClickMonth(!clickMonth)};
              if(flag === 1) {
                months[i].classList.remove('available');
                months[i].classList.add('disabled');
              }
              
              if(Number(months[i].innerText.substring(6)) === today.getMonth() + 1) {
                flag = 1;
              }   
            }
          }
        } else {
          if(Number(years[1].innerText) === today.getFullYear()) {
            const months = document.getElementsByClassName('monthPanel');
            
            let flag = 0;
            if(months.length !== 0) {
              
              for(let i = 12; i < months.length; i++){

                if(flag === 1) {
                  months[i].classList.remove('available');
                  months[i].classList.add('disabled');
                }
                if(Number(months[i].innerText.substring(6)) === today.getMonth() + 1) {
                  flag = 1;
                }   
              }
            }
          } 
        }
      }
    }
  },[datePick, ref, clickMonth]);

  let maxDate = new Date();
  maxDate.setDate(maxDate.getDate() - 1);
  return (
    <>
      <div ref={ref} className={ flex === 'right' ? "main_toggle_button  right" : "main_toggle_button" }>
        {isDatePicker ? 
        (<>
          {active === 1 || active === 0 ?
            <div className="date_picker">
              <DateRangePicker
                initialSettings={{
                  opens: 'left',
                  buttonClasses: ['none_button'],
                  locale: {
                    format: 'DD/MM/YYYY',
                    separator: ' → ',
                    daysOfWeek: ["CN", "T2", "T3", "T4", "T5", "T6", "T7"],
                    monthNames: ['Tháng 1 -','Tháng 2 -','Tháng 3 -','Tháng 4 -','Tháng 5 -','Tháng 6 -','Tháng 7 -','Tháng 8 -','Tháng 9 -','Tháng 10 -','Tháng 11 -','Tháng 12 -']
                  },
                  maxSpan: {
                    days: 60
                  },
                  startDate: datePick.fromDate,
                  endDate: datePick.toDate,
                  maxDate: maxDate,
                }}
              >
                <button 
                  id='date_button'
                  className="toggle_button"
                  style={{
                    paddingLeft: '15px',
                    paddingRight: '15px',
                    height: '50px',
                    boxShadow: 'none',
                    background: '#499AAF',
                    color: '#fff',
                  }}
                  onClick={() => {
                    setActive(1);
                    button1.onClick();
                  }}
                >
                  {button1.name}
                </button>
              </DateRangePicker> 
            </div> : 
            <button 
              className="toggle_button"
              onClick={() => {
                setActive(1);
                button1.onClick();
              }}
            >
              {button1.name}
            </button>
          }
          {active === 2 ?
            <Monthrangepicker
              locale={{
                format: 'MM/YYYY',
                separator: ' → ',
                monthNames: ['Tháng 1','Tháng 2','Tháng 3','Tháng 4','Tháng 5','Tháng 6','Tháng 7','Tháng 8','Tháng 9','Tháng 10','Tháng 11','Tháng 12']
              }}
              buttonClasses= {['none_button']}
              opens='left'
              startDate={datePick.fromDate}
              endDate={datePick.toDate}
              dateLimit={{
                'months': 59,
              }}
              maxDate={moment(maxDate.toISOString())}
            >
              <button
                id="month_button"
                className="toggle_button"
                style={{
                  paddingLeft: '15px',
                  paddingRight: '15px',
                  height: '50px',
                  boxShadow: 'none',
                  background: '#499AAF',
                  color: '#fff',
                }}
                onClick={() => {
                  setActive(2);
                  setClickMonth(!clickMonth);
                  button2.onClick();
                }}
              >
                {button2.name}
              </button>
            </Monthrangepicker> 
            : 
            <button
              className="toggle_button"
              onClick={() => {
                setActive(2);
                button2.onClick();
              }}
            >
              {button2.name}
            </button>
          }
        </>) : (<>
          <button 
            className={active === 1 || active === 0 ? "toggle_button active_toggle_button": "toggle_button"}
            onClick={() => {
              button1.onClick();
              setActive(1);
            }}
          >
            {button1.name}
          </button>
          <button
            className={active === 2  ? "toggle_button active_toggle_button": "toggle_button"}
            onClick={() => {
              button2.onClick();
              setActive(2);
            }}
          >
            {button2.name}
          </button>
        </>
        )
      }    
      </div>
    </>
  );
}

export default ToggleButton;